export enum GateTypeEnum {
  SCOUTING = 'scouting',
  NEGOTIATION = 'negotiation',
  TRAINING_GK = 'training_gk',
  TRAINING_DF = 'training_df',
  TRAINING_MF = 'training_mf',
  TRAINING_AT = 'training_at',
  COINS = 'coins',
  BALANCE = 'balance',
}

